// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "footer[data-v-384e2041]{max-width:71.25rem;margin:0 auto;border-top:1px solid rgba(0,0,0,.12);padding:1.5rem}footer p[data-v-384e2041]{color:rgba(0,0,0,.38);text-align:center}main[data-v-384e2041]{padding:1rem 1.5rem;position:relative}main.loading[data-v-384e2041]{height:0;opacity:0;overflow:hidden}.inline-loader[data-v-384e2041]{margin-top:9.375rem;display:flex;justify-content:center}", ""]);
// Exports
module.exports = exports;
